export default __webpack_public_path__ + "static/media/logo.11a5855b.svg";